module.exports = __webpack_public_path__ + "img/null_pic.76b115b8.png";